import React from 'react';
import Link, { navigateTo } from 'gatsby-link';
import PropTypes from 'prop-types';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import MarvelLink from '@marvelapp/marvel-ui/link';

export default function NavDropdown({ url, items, title, active }) {
  const type = active ? 'blue' : 'dark';
  const paddingBottom = active && items ? 'xxs' : 'xxxs';

  return (
    <Spacing type="paddingTop" size="xxxs">
      <Spacing type="paddingBottom" size={paddingBottom}>
        <Link className="fontSize-l fontWeight-5" to={url}>
          <MarvelLink type={type}>{title}</MarvelLink>
        </Link>
        <Spacing type="padding" position="topBottom" size="s">
          {items &&
            active &&
            items.map(dropdownItem => (
              <Spacing type="padding" position="left" size="m">
                <Spacing type="padding" position="topBottom" size="xxs">
                  <Paragraph tag="div" size="m" color="silver">
                    <MarvelLink onClick={e => scrollTo(e, dropdownItem.url)}>
                      {dropdownItem.title}
                    </MarvelLink>
                  </Paragraph>
                </Spacing>
              </Spacing>
            ))}
        </Spacing>
      </Spacing>
    </Spacing>
  );
}

function scrollTo(e, targetUrl) {
  const idx = targetUrl.indexOf('#');
  const hashString = idx !== -1 ? targetUrl.substring(idx + 1) : '';
  const targetElement = document.getElementById(hashString);

  if (targetElement) {
    e.preventDefault();
    history.pushState({}, '', targetUrl);
    setTimeout(() => {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start',
      });
    }, 50);
  } else {
    navigateTo(targetUrl);
  }
}

NavDropdown.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  active: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/Sidebar/NavDropdown.js